import { useCallback, useEffect } from 'react';
import { rootStore } from '../../../../mobx/rootStore';
import { COLOR_THEME, COLOR_THEME_TYPE } from '../../../../global/constants';
import { getIsDarkMode } from '../../../../helpers/common';
import UserPreferenceSingleton from '../../../../helpers/userPreferenceSingleton';

export const useThemeSwitcher = () => {
  const { appStore } = rootStore;
  const { themeType } = appStore;

  // Load theme data
  const loadThemeData = useCallback(() => {
    const theme = UserPreferenceSingleton.getInstance().getThemeMode();
    if (theme) {
      appStore.setThemeType(theme as number);
    }
  }, [appStore]);

  useEffect(() => {
    loadThemeData();
  }, [loadThemeData]);

  // Get theme mode
  const getThemeMode = useCallback((theme: string) => {
    if (theme === 'dark') {
      return COLOR_THEME.DARK;
    } else if (theme === 'light') {
      return COLOR_THEME.LIGHT;
    }
    return COLOR_THEME.SYSTEM_DEFAULT;
  }, []);

  // Handle theme change
  const onThemeChange = useCallback(
    (theme: string) => {
      const themeMode = getThemeMode(theme);
      let resolvedThemeType;

      if (theme !== COLOR_THEME_TYPE.SYSTEM) {
        resolvedThemeType = theme;
      } else if (getIsDarkMode()) {
        resolvedThemeType = COLOR_THEME_TYPE.DARK;
      } else {
        resolvedThemeType = COLOR_THEME_TYPE.LIGHT;
      }

      // Save theme mode to local storage
      UserPreferenceSingleton.getInstance().setThemeMode(themeMode);
      appStore.setThemeMode(resolvedThemeType);
      appStore.setThemeType(themeMode);

      if (window.electronApi) {
        window.electronApi.changeTheme(theme);
      }

      // Trigger a real click on the blank-div-click element
      const el = document.querySelector('.blank-div-click') as HTMLElement | null;
      if (el) {
        el.click();
      }
    },
    [getThemeMode, appStore]
  );

  return {
    themeType,
    onThemeChange,
    loadThemeData
  };
};
